module.exports = __webpack_public_path__ + "img/18-icon.39e6ede3.jpg";